import React from 'react';
import { Table, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';

const SysadminUserDependentsTable = (props) => {
    return (
        <Table celled selectable>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>NRIC</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    props.userDetail.family && props.userDetail.family.length === 0 ?
                        <Table.Row>
                            <Table.Cell colSpan={8} textAlign="center">
                                <Message info>
                                    User have no dependents.
                                </Message>
                            </Table.Cell>
                        </Table.Row>
                    :
                    _.map(props.userDetail.family, (user) => {
                        const {
                            _id,
                            nric,
                            name,
                        } = user;
                        return (
                            <Table.Row key={_id}>
                                <Table.Cell>
                                    <Link to={`/systemadmin/client/${props.userDetail.companyId}/user/${_id}/`}>
                                        {_id}
                                    </Link>
                                </Table.Cell>
                                <Table.Cell>{nric}</Table.Cell>
                                <Table.Cell>{name}</Table.Cell>
                            </Table.Row>
                        );
                    })
                }
            </Table.Body>
        </Table>
    );
}

export default SysadminUserDependentsTable;